export default "__VITE_ASSET__CY9s_WQ0__"